import React from 'react';
import { SecondaryNavItem } from '@zola-helpers/client/dist/es/constants/navConstants';

export const SET_SIDE_DRAWER = 'zola/sideDrawer/SET_SIDE_DRAWER';

export type SideDrawerProps = {
  quickLinksData?: SecondaryNavItem[];
};

export type SideDrawerContent = React.ComponentType<{
  isOpen: boolean;
  closeDrawer: () => void;
  props?: SideDrawerProps;
}>;

export type SetSideDrawerActionType = {
  type: typeof SET_SIDE_DRAWER;
  payload: { content: SideDrawerContent | null; props?: SideDrawerProps };
};

export type SideDrawerActionTypes = SetSideDrawerActionType;
